export function Storagesize(input = '') {
  const text = String(input);

  let bytes = 0;
  if (typeof Buffer !== 'undefined' && Buffer.byteLength) {
    bytes = Buffer.byteLength(text, 'utf8');
  } else if (typeof TextEncoder !== 'undefined') {
    bytes = new TextEncoder().encode(text).length;
  } else {
    bytes = text.length;
  }

  return {
    bits: bytes * 8,
    bytes,
    kb: bytes / 1024,
    mb: bytes / (1024 * 1024),
    gb: bytes / (1024 * 1024 * 1024),
  };
}

export function FormatStorageSize(input = '') {
  const s = Storagesize(input);

  if (s.gb >= 1) return `${s.gb.toFixed(4)} GB`;
  if (s.mb >= 1) return `${s.mb.toFixed(2)} MB`;
  if (s.kb >= 1) return `${s.kb.toFixed(2)} KB`;
  return `${s.bytes} bytes`;
}